var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddonAadido(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#6fc0f7;}.cls-3{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-addon-a\xF1adido") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_9",
    "data-name": "38 copia 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.91,99.73a6.79,6.79,0,0,0-6.78,6.79V122a6.47,6.47,0,1,0,3,.1V106.52a3.81,3.81,0,0,1,3.8-3.8h26.83v-3Zm-2,28.57a3.46,3.46,0,1,1-3.46-3.45A3.46,3.46,0,0,1,143.89,128.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.6,109.07H82.09a6.45,6.45,0,1,0,0,3H100.6a3.8,3.8,0,0,1,3.8,3.8v56.32h3V115.86A6.79,6.79,0,0,0,100.6,109.07Zm-24.77,5a3.46,3.46,0,1,1,3.45-3.46A3.46,3.46,0,0,1,75.83,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.94,79.61a6.45,6.45,0,0,0-6.26,5H58.46v3H94.68a6.44,6.44,0,1,0,6.26-7.94Zm0,9.9a3.46,3.46,0,1,1,3.46-3.45A3.46,3.46,0,0,1,100.94,89.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.72,86a6.44,6.44,0,1,0-6.26-7.94H123.32a6.8,6.8,0,0,0-6.79,6.79v87.32h3V84.86a3.8,3.8,0,0,1,3.8-3.8h18.14A6.45,6.45,0,0,0,147.72,86Zm0-9.9a3.46,3.46,0,1,1-3.46,3.46A3.46,3.46,0,0,1,147.72,76.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.92,109.54a6.44,6.44,0,0,0-1.49,12.7v19.63a3.81,3.81,0,0,1-3.8,3.8H141.81a6.79,6.79,0,0,0-6.79,6.78v19.73h3V152.45a3.8,3.8,0,0,1,3.8-3.8h11.82a6.79,6.79,0,0,0,6.78-6.78V122.24a6.44,6.44,0,0,0-1.49-12.7Zm0,9.89a3.46,3.46,0,1,1,3.45-3.45A3.46,3.46,0,0,1,158.92,119.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.69,152.2V136.77A6.8,6.8,0,0,0,87.9,130H58.46v3H87.9a3.8,3.8,0,0,1,3.8,3.8V152.2a6.44,6.44,0,1,0,3,0Zm-1.5,9.71a3.46,3.46,0,1,1,3.46-3.45A3.46,3.46,0,0,1,93.19,161.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.59,57.91a9.15,9.15,0,0,1,9.15,9.15v96a9.15,9.15,0,0,1-9.15,9.15h-96A9.15,9.15,0,0,1,58.46,163v-96a9.15,9.15,0,0,1,9.15-9.15h96m0-4.73h-96A13.89,13.89,0,0,0,53.73,67.06v96a13.89,13.89,0,0,0,13.88,13.88h96A13.89,13.89,0,0,0,177.47,163v-96a13.89,13.89,0,0,0-13.88-13.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddonAadido);
export default __webpack_public_path__ + "static/media/ic-addon-añadido.687acc552f0ff225f8c8e24ec6ff09ea.svg";
export { ForwardRef as ReactComponent };